<script lang="ts">
  import LoadMore from '$components/directory/load-more.svelte';
  import ShopTheLook from '$components/shop-the-look.svelte';
  import { t } from '$lib/i18n';
  import { lang } from '$lib/lang';
  import { getStoryblok } from '$lib/storyblok';
  import { cn } from '$lib/utils';
  import type { ShopTheLookIndexStoryblok } from '$types/bloks';
  import type { ISbResult } from '@storyblok/js';
  import { createQuery } from '@tanstack/svelte-query';

  export let block: ShopTheLookIndexStoryblok;

  let pageNumber = 1;

  const storyblok = getStoryblok();

  let looksArray: Array<ISbResult['data']['stories']> = [];

  $: client = createQuery({
    staleTime: 5 * 60 * 1000,
    queryKey: ['shop-the-look', $lang, pageNumber],
    queryFn: async () => {
      return await storyblok.get('cdn/stories/', {
        content_type: 'shop-the-look',
        page: pageNumber,
        per_page: Number(block.items_per_page) || 6,
        cv: Date.now()
      });
    }
  });

  $: if ($client.data) {
    if (looksArray.length === 0) {
      looksArray = $client.data.data.stories;
    } else {
      looksArray = [...looksArray, ...$client.data.data.stories];
    }
  }
</script>

<section class="overflow-hidden py-12 px-4 lg:px-8">
  <div class="container mx-auto">
    <h2 class="text-5xl font-semibold mb-10">{block.title}</h2>
    <p class="text-md text-primary/40 mb-4">
      {$client.data?.total || 0}
      {$t('shop-the-look.looks')}
    </p>
    <div class="flex gap-2 sm:gap-4 flex-wrap flex-col sm:flex-row">
      {#if looksArray}
        {#each looksArray as lookItem}
          {@const look = lookItem.content}
          <ShopTheLook {look} name={lookItem.name} class={cn('w-full sm:w-1/4 flex-grow')} />
        {/each}
      {/if}
    </div>
    <LoadMore
      total={$client.data?.total || 0}
      showing={looksArray.length}
      hasNextPage={looksArray.length < ($client.data?.total || 0)}
      loading={$client.isLoading}
      on:loadMore={() => (pageNumber = pageNumber + 1)}
    />
  </div>
</section>
